import type { FilterGroupV1, FilterGroupV1Option, FilterGroupV1Type } from '@/features/filter/filter-data-v1-type';

import { isFilterSingleMandatory } from '@/features/filter/filter-data/service/filter-data-service';

export type QuickFilterGroup = {
    hasSelectedFilterOptions: boolean;
    name: string;
    selectedFilterOptions: string[];
    selectedQuickFilterTitle: string;
    title: string;
    type: FilterGroupV1Type;
};

const processFilterGroup = (group: FilterGroupV1): QuickFilterGroup[] => {
    const result: QuickFilterGroup[] = [];

    if (group.groups && group.groups.length > 0) {
        result.push(...group.groups.flatMap(processFilterGroup));
    }

    // Process current group if it's a quick filter
    if (group.isQuickFilter && group.options.length > 0) {
        const selectedFilterOptions = getSelectedFilterOptions(group);
        const selectedQuickFilterTitle = buildSelectedQuickfilterTitle(group, selectedFilterOptions);

        result.push({
            hasSelectedFilterOptions: selectedFilterOptions.length > 0,
            name: group.name,
            selectedFilterOptions: selectedFilterOptions.map((option) => option.name),
            selectedQuickFilterTitle,
            title: group.title,
            type: group.type,
        });
    }

    return result;
};

export const buildQuickFilterCollection = (filterGroupCollection: FilterGroupV1[]): Array<QuickFilterGroup> => {
    return filterGroupCollection.flatMap(processFilterGroup).sort((groupA, groupB) => {
        if (groupA.hasSelectedFilterOptions && groupB.hasSelectedFilterOptions) {
            return 0;
        }
        return groupA.hasSelectedFilterOptions ? -1 : 0;
    });
};

const getSelectedFilterOptions = (group: FilterGroupV1): FilterGroupV1Option[] => {
    return group.options.filter((option) => {
        // options is selected and not the default
        if (option.isSelected && !option.isDefault) {
            return true;
        }
        // options is default and mandatory (e.g. activity filter)
        if (isFilterSingleMandatory(group.type) && option.isDefault) {
            return true;
        }
        return false;
    });
};

const buildSelectedQuickfilterTitle = (
    group: FilterGroupV1, //
    selectedQuickFilter: FilterGroupV1Option[],
): string => {
    if (selectedQuickFilter.length === 0) {
        return group.title;
    }
    if (selectedQuickFilter.length === 1 && selectedQuickFilter[0]) {
        const optionsTitle = selectedQuickFilter[0].shortTitle || selectedQuickFilter[0].title;
        return `${group.title}: ${optionsTitle}`;
    }

    return `${group.title} (${selectedQuickFilter.length})`;
};
